import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { firstValueFrom, timer } from 'rxjs';

import { VisibilityService } from './visibility.service';

/**
 * 0.56.6 — Platform-Admin-Gate für FATIP-internale Module.
 *
 * Aktuelle Verwendungsstellen: `/modules/system-tools`, `/modules/api-
 * management`, `/modules/cloud-governance`, `/modules/platform` (seit U43)
 * und `/modules/bulk-onboarding` (der Guard sitzt dort auf der ''-Child-Route,
 * die Parent-Route in app.routes.ts trägt keinen canMatch), fünf Stellen,
 * je nur für Plattform-Betrieb gedacht. Externe API-Konsumenten lesen die
 * öffentlich verfügbaren Endpunkte später über den API-Katalog
 * (`/modules/apis`).
 *
 * Heuristik: wenn die VisibilityService-Snapshot noch nicht geladen
 * ist (erster Request), polling 100 ms bis 1 s. Wenn das Ergebnis
 * `is_platform_admin === false` (oder gar nicht aufgelöst), wird auf
 * `/modules` umgeleitet. Erfolgsfall: erlaubt die Route. Fehlerfall
 * fail-closed.
 */
export const platformAdminGuard: CanMatchFn = async () => {
  const vis = inject(VisibilityService);
  const router = inject(Router);

  for (let i = 0; i < 10; i++) {
    const v = vis.snapshot();
    if (v !== null) {
      if (v.is_platform_admin) return true;
      router.navigate(['/modules'], { replaceUrl: true });
      return false;
    }
    await firstValueFrom(timer(100));
  }
  // Snapshot blieb 1 s lang null → fail-closed.
  router.navigate(['/modules'], { replaceUrl: true });
  return false;
};
